import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import { usePageLang } from '@/hooks/usePageLang';

export default function GuidesPage() {
  const { t } = useTranslation(['pages', 'home']);
  const { currentLang } = usePageLang();

  const guides = [
    { icon: 'ri-file-list-3-line', titleKey: 'guides_qc', descKey: 'guides_qc_desc', slug: 'allchinabuy-qc-guide' },
    { icon: 'ri-truck-line', titleKey: 'guides_shipping', descKey: 'guides_shipping_desc', slug: 'allchinabuy-shipping-comparison' },
    { icon: 'ri-building-line', titleKey: 'guides_warehouse', descKey: 'guides_warehouse_desc', slug: 'allchinabuy-warehouse-process' },
    { icon: 'ri-user-star-line', titleKey: 'guides_seller', descKey: 'guides_seller_desc', slug: 'finding-trusted-sellers-allchinabuy' },
    { icon: 'ri-shield-check-line', titleKey: 'guides_safety', descKey: 'guides_safety_desc', slug: 'is-allchinabuy-safe' },
  ];

  return (
    <PageShell
      eyebrow={t('guides_eyebrow')}
      title={t('guides_h1')}
      intro={t('guides_intro')}
    >
      <div className="grid sm:grid-cols-2 gap-5">
        {guides.map((g) => (
          <Link
            key={g.slug}
            to={`/${currentLang}/blog/${g.slug}/`}
            className="bg-background-100 rounded-xl p-6 border border-background-200/40 hover:border-primary-300/60 transition-colors group"
          >
            <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
              <i className={`${g.icon} text-xl`}></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors">
              {t(g.titleKey, { ns: 'home' })}
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed mb-3">
              {t(g.descKey, { ns: 'home' })}
            </p>
            <span className="text-primary-600 text-sm font-medium inline-flex items-center gap-1">
              {t('blog_read')}
            </span>
          </Link>
        ))}
      </div>
    </PageShell>
  );
}